import { useContext } from "react";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";

export function TSwitch(props: {NS, DF}) {
   const {hasAccessToFeature} = useContext(ApplicationStateContext)
   if (hasAccessToFeature(Feature.ThemeNewSec)) {
      return props.NS
   }
   return props.DF
}